export enum ActionType {
  Save = 'Saved',
  Sync = 'Synced',
}
